const config = require("../config");

class CourseService {
  constructor(httpClient) {
    this.BASE_URL = config.BASE_URL;
    this.httpClient = httpClient;
  }

  async getAllCourses() {
    try {
      const response = await this.httpClient.get(
        this.BASE_URL + "/GetAllCourses?"
      );

      if (response.status === 401) {
        const error = new Error("Unauthorized");
        error.code = 401;
        throw error;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch courses.");
      }

      const courses = await response.json();
      return courses;
    } catch (error) {
      console.error("Error fetching courses: ", error);
      if (error.status === 401) {
        throw error;
      } else {
        return [];
      }
    }
  }


  async createCourse(course) {
    try {
      const response = await this.httpClient.post(
        this.BASE_URL + "/CreateCourse",
        course
      );

      if (response.status === 401) {
        const error = new Error("Unauthorized");
        error.code = 401;
        throw error;
      }

      return response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async batchUpdateCourses(coursesActionModel) {
    try {
      const response = await this.httpClient.post(
        this.BASE_URL + "/BatchCourseUpdate",
        coursesActionModel
      );

      if (response.status === 401) {
        const error = new Error("Unauthorized");
        error.code = 401;
        throw error;
      }

      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updateCourse(course) {
    try {
      const response = await this.httpClient.post(
        this.BASE_URL + "/UpdateCourse",
        course
      );

      if (response.status === 401) {
        const error = new Error("Unauthorized");
        error.code = 401;
        throw error;
      }

      return response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async deleteCourse(course) {
    try {
      const response = await this.httpClient.post(
        this.BASE_URL + "/DeleteCourseById",
        course
      );

      if (response.status === 401) {
        const error = new Error("Unauthorized");
        error.code = 401;
        throw error;
      }

      return response.json();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updatePassword(passwordModel) {
    try {
      await this.httpClient.post(
        this.BASE_URL + "/UpdatePassword",
        passwordModel
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default CourseService;
